import { SSRAuthClient } from "@react-keycloak-fork/ssr";

export const BuildLogoutUrl = ({
  authServerUrl,
  realm,
  idToken,
  clientId,
}: SSRAuthClient) => {
  const params = new URLSearchParams({
    post_logout_redirect_uri: window.location.origin,
  });
  if (idToken !== undefined && idToken !== "") {
    params.set("id_token_hint", idToken);
  } else if (clientId !== undefined && clientId !== "") {
    params.set("client_id", clientId);
  }

  return `${authServerUrl ?? ""}realms/${
    realm ?? ""
  }/protocol/openid-connect/logout?${params.toString()}`;
};
